<template>

<v-app style="background-color: transparent">
 
    <PasswordReset v-if="showPasswordReset" @close="togglePasswordReset()"></PasswordReset>

    <v-container fill-height style="max-width:500px; width:auto;">
    
      <v-card :class="{ 'signup-form': !showLoginForm }" style="background-color:transparent" class="elevation-0">

        <v-form v-if="showLoginForm" @submit.prevent>

          <v-card-title class="display-3 text-sm-h1 white--text font-weight-bold pt-0 pb-0">Welcome</v-card-title>

          <v-card-text>

            <v-card-text class="white--text pl-0 pt-0">Email</v-card-text>
            
            <v-text-field solo v-model.trim="signupForm.email" type="text" placeholder="you@email.com" id="email1" class="body-2 grey--text text--darken-1" />
          
            <v-card-actions class="pa-0">

              <v-btn color="primary" class="font-weight-medium" @click="signup()" style="height:50px">Sign up</v-btn>

              <v-spacer></v-spacer>
        
            </v-card-actions>

        </v-card-text>
        
        </v-form>

      </v-card>

    </v-container>

</v-app>

</template>


<script>
import PasswordReset from '@/components/PasswordReset'

export default {
  components: {
    PasswordReset
  },
  data() {
    return {
      signupForm: {
        email: '',
        apiKey: ''  
      },
      showLoginForm: true,
      showPasswordReset: false
    }
  },
  methods: {
    toggleForm() {
      this.showLoginForm = !this.showLoginForm
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset
    },
    signup() {
      this.$store.dispatch('signup', {
        email: this.signupForm.email,
        apiKey: this.$route.query.apiKey
      })
    }
  }
}
</script>
